import VueCharts from 'vue-chartjs';
import moment from 'moment';

const TICK_INTERVAL = 7;
const Y_TICK_INTERVAL = 5;

export default {
    extends: VueCharts.Line,
    mixins: [VueCharts.mixins.reactiveProp],
    props: ['chartData', 'interval', 'created'],
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        title() {
                            return '';
                        },
                        label(tooltipItem, data) {
                            let label = data.datasets[tooltipItem.datasetIndex].label || '';
                            if (label) {
                                label += `: ${tooltipItem.yLabel}`;
                                if (tooltipItem.datasetIndex === 0) {
                                    label += data.t.unit_user_count;
                                } else if (tooltipItem.datasetIndex === 1) {
                                    label += data.t.unit_user_count;
                                } else {
                                    label += data.t.unit_request_count;
                                }
                            }
                            return label;
                        },
                        footer(tooltipItem, data) {
                            if (typeof data.labels[tooltipItem[0].index] === 'object') {
                                if (data.t.interval === '1d') {
                                    return data.labels[tooltipItem[0].index][0];
                                }
                                return data.labels[tooltipItem[0].index].join(' ');
                            }
                            return data.labels[tooltipItem[0].index];
                        },
                    },
                    bodySpacing: 5,
                    footerSpacing: 7,
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            maxRotation: 0,
                            minRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: TICK_INTERVAL,
                            callback(value, index, values) {
                                if (value.length === 2) {
                                    if (this.chart.data.t.interval === '1d') {
                                        return moment(value[0]).format('MM-DD');
                                    }
                                    const tm = value[1].split(':');
                                    tm.pop();
                                    return [moment(value[0]).format('MM-DD'), tm.join(':')];
                                }
                                if (this.chart.data.t.interval === '1d') {
                                    return moment(value).format('MM-DD');
                                }
                                return moment(value).format('MM-DD HH:mm');
                            },
                        },
                    }],
                    yAxes: [{
                        fill: false,
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                        ticks: {
                            min: 0,
                            maxTicksLimit: Y_TICK_INTERVAL,
                            callback(value, index, values) {
                                if (Math.floor(value) === value) {
                                    return value;
                                }
                            },
                        },
                    },
                    // {
                    //     fill: false,
                    //     display: true,
                    //     position: 'right',
                    //     id: 'y-axis-2',
                    //     gridLines: {
                    //         drawOnChartArea: false, // only want the grid lines for one axis to show up
                    //     },
                    //     ticks: {
                    //         min: 0,
                    //         maxTicksLimit: Y_TICK_INTERVAL,
                    //         callback(value, index, values) {
                    //             if (Math.floor(value) === value) {
                    //                 return value;
                    //             }
                    //         },
                    //     },
                    // }
                    ],
                },
            },
        };
    },
    mounted() {
        this.addPlugin({
            beforeInit(chart) {
                chart.data.labels.forEach((e, i, a) => {
                    e = moment(e).format('YYYY-MM-DD HH:mm:ss');
                    if (/\s/.test(e)) {
                        a[i] = e.split(/\s/);
                    }
                });
            },
        });
    },
    methods: {
        initialize() {
            // this.paddingData();
            this.loadChart();
        },
        loadChart() {
            let color = Chart.helpers.color;
            this.renderChart({
                t: {
                    unit_user_count: this.$t('words.unit_user_count'),
                    unit_request_count: this.$t('words.unit_request_count'),
                    interval: this.interval,
                },
                labels: this.chartData.labels,
                datasets: [
                    {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: this.$t('words.acc_user_count'),
                        backgroundColor: color('#66CC99').alpha(1).rgbString(),
                        borderColor: '#66CC99',
                        borderWidth: 2,
                        data: this.chartData.results.accUser,
                        yAxisID: 'y-axis-1',
                    },
                    {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: this.$t('words.cur_user_count'),
                        backgroundColor: color('#f87979').alpha(1).rgbString(),
                        borderColor: '#f87979',
                        borderWidth: 2,
                        data: this.chartData.results.curUser,
                        yAxisID: 'y-axis-1',
                    },
                    {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: this.$t('words.request_count'),
                        backgroundColor: color('#FFDF58').alpha(1).rgbString(),
                        borderColor: '#FFDF58',
                        borderWidth: 2,
                        data: this.chartData.results.count,
                        yAxisID: 'y-axis-1',
                    },
                ]
            }, this.options);
        },
        updateChart() {
            this.paddingData();

            this._data._chart.data.labels = this.chartData.labels;
            this._data._chart.data.datasets[0].data = this.chartData.results.accUser;
            this._data._chart.data.datasets[1].data = this.chartData.results.curUser;
            this._data._chart.data.datasets[2].data = this.chartData.results.count;
        },
        paddingData() {
            if (this.chartData.results.accUser.length > 0) {
                if (this.chartData.results.accUser[0] === 0 && this.chartData.results.curUser[0] === 0 && this.chartData.results.count[0] === 0) {
                    // remove first item
                    this.chartData.labels = _.drop(this.chartData.labels, 1);
                    this.chartData.results.accUser = _.drop(this.chartData.results.accUser, 1);
                    this.chartData.results.curUser = _.drop(this.chartData.results.curUser, 1);
                    this.chartData.results.count = _.drop(this.chartData.results.count, 1);
                }
            }
            if (this.chartData.results.accUser.length > 0) {
                const lastIndex = this.chartData.results.accUser.length - 1;
                if (this.chartData.results.accUser[lastIndex] === 0 && this.chartData.results.curUser[lastIndex] === 0 && this.chartData.results.count[lastIndex] === 0) {
                    // remove last item
                    this.chartData.labels = _.dropRight(this.chartData.labels, 1);
                    this.chartData.results.accUser = _.dropRight(this.chartData.results.accUser, 1);
                    this.chartData.results.curUser = _.dropRight(this.chartData.results.curUser, 1);
                    this.chartData.results.count = _.dropRight(this.chartData.results.count, 1);
                }
            }
        },
    },
    watch: {
        // created(newValue, oldValue) {
        //     this.paddingData();
        //     this.loadChart();
        // },
    },
};
